module.exports = "<vb-generic-selection-input\r\n  inputId=\"depot-input\"\r\n  label=\"Lager\"\r\n  [items]=\"depotList\"\r\n  [selectedItem]=\"item\"\r\n  [control]=\"control\"\r\n  (itemSelected)=\"onDepotSelected($event)\"\r\n  (itemChanged)=\"onDepotChanged($event)\"\r\n  (itemDeselected)=\"onDepotUnselected()\">\r\n</vb-generic-selection-input>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/store-management/depot/depot-selection/depot-selection.component.html
// module id = ./src/app/store-management/depot/depot-selection/depot-selection.component.html
// module chunks = main